import { EmptyState } from "@components";

export function InfractionsEmptyState() {
	return (
		<EmptyState className="my-10 max-w-[352px] gap-6">
			<EmptyState.Illustration
				className="h-[180px] w-[175px]"
				size="sm"
				type="documents"
			/>
			<div className="flex flex-col items-center gap-6">
				<div className="flex flex-col items-center gap-2">
					<EmptyState.Title className="font-semibold text-md text-primary leading-6">
						Nenhuma infração cadastrada
					</EmptyState.Title>
					<EmptyState.Description className="text-center text-sm text-tertiary leading-5">
						Clique no botão abaixo para adicionar uma nova infração
					</EmptyState.Description>
				</div>
			</div>
		</EmptyState>
	);
}
